export default __webpack_public_path__ + "static/media/white-tickmark-in-purple-circle.dcaffd53.svg";